export const GET_RIDES_ALL_LIST_START = "GET_RIDES_ALL_LIST_START";
export const GET_RIDES_ALL_LIST_ERROR = "GET_RIDES_ALL_LIST_ERROR";
export const GET_RIDES_ALL_LIST_SUCCESS = "GET_RIDES_ALL_LIST_SUCCESS"
export const GET_RIDES_AVAILABLE_LIST_SUCCESS="GET_RIDES_AVAILABLE_LIST_SUCCESS"
export const GET_RIDES_ON_TOUR_LIST_SUCCESS="GET_RIDES_ON_TOUR_LIST_SUCCESS";
export const GET_RIDES_ASSIGNED_LIST_SUCCESS = "GET_RIDES_ASSIGNED_LIST_SUCCESS"
export const GET_RIDES_MAINTENANCE_LIST_SUCCESS = "GET_RIDES_MAINTENANCE_LIST_SUCCESS"

export const GET_UNDER_VERIFICATION_RIDES_LIST_START = "GET_UNDER_VERIFICATION_RIDES_LIST_START";
export const GET_UNDER_VERIFICATION_RIDES_LIST_ERROR = "GET_UNDER_VERIFICATION_RIDES_LIST_ERROR";
export const GET_UNDER_VERIFICATION_RIDES_LIST_SUCCESS = "GET_UNDER_VERIFICATION_RIDES_LIST_SUCCESS"